<template>
  <div class="message-box">
    <div class="message-title">
      <svg-icon icon-class="message-success" />
      订单提交成功
    </div>
    <div class="message-desc" v-if="activity.cancelTime > 0">订单请在{{activity.cancelTime}}分钟内付款,超时订单将自动关闭！</div>
    <div class="message-button">
      <router-link :to="{ name: 'pay-pay', params: { id: id } }">
        <el-button type="primary" size="small">立即支付</el-button>
      </router-link>
    </div>
  </div>
</template>

<script>

  import { createNamespacedHelpers } from 'vuex'

  const { mapState: activityMapState } = createNamespacedHelpers('activity')

  export default {
    props: {
      id: {
        type: Number,
        default: 0
      },
    },
    methods: {
    },
    computed: {
      ...activityMapState([
        'activity'
      ]),
    },
}
</script>
